// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable max-lines */
import Styled, { css } from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy/views';
import Button from '@tcp/core/src/components/common/atoms/Button/views';
import Image from '@tcp/core/src/components/common/atoms/Image/views';
import { snjPrimary } from './CommonStyle';
import { BadgeItem } from '../views/ProductItemComponents';
import ProductAltImages from '../views/ProductAltImages';

const applyBrandSpecificColor = (props) =>
  props.theme.brandSpecificStyles.PRODUCT_LISTING_BRAND_SPECIFIC_COLOR;

const isFavoriteViewColor = (props) => {
  const {
    isFavoriteView,
    theme: {
      colorPalette: { white },
    },
  } = props;
  return isFavoriteView ? props.theme.brandSpecificStyles.PRODUCTS_GRID_ITEM.BUTTON_BGCOLOR : white;
};

const bundleColor = (props) => {
  return props.item && props.item.productInfo && props.item.productInfo.bundleProduct;
};

const getMarginTop = (props) => {
  if (props.isFavoriteView && !props.isGuestFavWeb) {
    return '7px';
  }

  if (props.isFavoriteView && props.isGuestFavWeb && !props.isLoggedIn) {
    return 'auto';
  }

  return '';
};

const getPLPSLPAddToCartCTAStyle = (props) => {
  if (props.isTileRedesignAB && !props.isFavoriteView && props.setPLPSLPAddToCartCTA !== 'icon') {
    return ` display: flex;
    align-items: center;
    margin-bottom: 2px;`;
  }

  return '';
};

export const StyledItemContainerInner = Styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  @media ${(props) => props.theme.mediaQuery.large} {
    height: 100%;
  }
  ${(props) => props.isAddedToBagRedesign && 'border: 0px;'}
  ${(props) => props.className !== 'pdp' && 'height: 100%;'}

  &:not(.pdp) {
    height: 100%;
  }
`;

export const StyledPointsAndRewards = Styled.p`
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  text-align: left;
  font-size: 11px;
  margin: 5px 0;
`;

export const StyledPointsAndRewards1 = Styled.span`
  color: ${(props) => props.theme.colors.PROMO.ORANGE};
  font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
`;

export const StyledPointsAndRewards2 = Styled.span`
  color: ${(props) => props.theme.colors.PROMO.BLUE};
  font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
`;

export const StyledPointsAndRewardsOr = Styled.span`
  font-size: ${(props) => props.theme.typography.fontSizes.fs13};
  color: ${(props) => props.theme.colors.BLACK};
  font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
`;

export const StyledPromotionWrapper = Styled.div`
   ${(props) => (props.isPDP ? `margin-top: auto;` : '')}
  flex: initial;
`;

export const StyledNoItemAvailableWrapper = Styled.div`
${(props) => {
  return !props.isTileRedesignAB && 'margin-top: auto;';
}}

@media ${(props) => props.theme.mediaQuery.medium} {
  margin-top: ${getMarginTop};
}

`;
export const StyledAddToBagButton = Styled(Button)`
  width: 100%;
  margin-top: ${(props) =>
    props.isSLP ? props.theme.spacing.ELEM_SPACING.XS : props.theme.spacing.ELEM_SPACING.XXS};
  color: ${(props) =>
    bundleColor(props) || props.isFavoriteView ? props.theme.colorPalette.white : ''};
  background-color: ${(props) =>
    props.item.productInfo.bundleProduct
      ? applyBrandSpecificColor(props)
      : isFavoriteViewColor(props)};
  &:hover {
    ${(props) =>
      !props.disabled
        ? `background: ${props.theme.brandSpecificStyles.PRODUCT_ADD_TO_BAG.BUTTON_BGCOLOR}; color: white;`
        : ''}
  }
  border-radius: ${(props) => (props.isNewPLPAtbCardTileEnabled ? '4px' : '')};
  &:hover:not([disabled]) {
    background: ${(props) => props.theme.brandSpecificStyles.PRODUCTS_GRID_ITEM.BUTTON_BGCOLOR};
    color: white;
  }

  &[disabled] {
    opacity: 0.5;
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    background-color: ${(props) =>
      bundleColor(props)
        ? applyBrandSpecificColor(props)
        : props.theme.brandSpecificStyles.PRODUCT_ADD_TO_BAG.BUTTON_BGCOLOR};
    color: white;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    padding: 0;
  }
  &#brand-snj {
    ${snjPrimary}
    &:hover {
      background-position: 90% 0;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
   ${(props) => (props.isSLP ? `margin-top: ${props.theme.spacing.ELEM_SPACING.SM};` : '')};
  }
`;

export const StyledTopBadgeContainer = Styled(BadgeItem)`
  min-height: 14px;
  width: 100%;
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};

  @media ${(props) => props.theme.mediaQuery.medium} {
    min-height: 16px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    min-height: 19px;
  }
`;

export const StyledInfluencerPickBadgeContainer = Styled(BadgeItem)`
  min-height: 14px;
  overflow: hidden;
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  @media ${(props) => props.theme.mediaQuery.medium} {
    min-height: 16px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    min-height: 19px;
  }
   > p {
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;;
   }
`;

export const StyledMoveItemContainer = Styled.div`
  position: relative;
`;

export const StyledHorizontalRule = Styled.hr`
  width: 100%;
  border-top: #E7E7E775;
`;

export const StyledMoveItemButton = Styled(Button)`
  margin-top: 3px;
  padding: 0;
  text-transform: none;
  text-align: left;
  color:#595959;
  font-weight: 700;
  letter-spacing: normal;
  outline: none;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  white-space: nowrap;
  min-height: 25px;
  &:focus {
    background: transparent;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    }

  &.dismiss-btn {
    min-height: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    @media ${(props) => props.theme.mediaQuery.medium} {
      min-height: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
    }
  }
`;

export const StyledMoveItemSection = Styled.div`
  min-width: 310px;
  border: solid 1px ${(props) => props.theme.colors.BUTTON.WHITE.BORDER};
  background: ${(props) => props.theme.colors.WHITE};
  position: absolute;
  z-index: 2;
  top: 40px;
  right: 0;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    &.item__even {
      right: 0;
    }
    &.item__odd {
      left: 0;
    }
  }
`;

export const StyledFavoriteMovePurchaseSection = Styled.div`
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
  flex-direction: ${(props) => (props.isFavPage ? 'row' : 'column')};
  align-items:${(props) => (props.isFavPage ? 'center' : '')};

  @media ${(props) => props.theme.mediaQuery.large} {
    flex-direction: row;
  }
`;

export const StyledAccordianItemArrow = Styled(Image)`
  padding-left: 4px;
`;

export const StyledEmptyColorChipsContainer = Styled.div`
  min-height: 35px;
  @media ${(props) => props.theme.mediaQuery.large} {
    min-height: 40px;
  }
`;
/* eslint-disable no-nested-ternary */
export const StyledProductImageContainer = Styled(ProductAltImages)`
  overflow: hidden;
  position: relative;
  ${(props) =>
    props.isPLPImageHeightBasedOnAspectRatio
      ? `
  padding-top:124%;
  width:100%;`
      : !props.isFavPage
      ? `
      height: 223px;
      max-height: 320px;
 @media (min-width: 429px) and (max-width: 528px) {
   height: ${props.isSuggestedItem ? '197px' : '267px'};
 }
 @media (min-width: 529px) and ${props.theme.mediaQuery.mediumMax} {
   height: ${props.isSuggestedItem ? '205px' : '320px'};
 }
@media ${props.theme.mediaQuery.smallOnly} {
   height: 215px;
 }
 @media ${props.theme.mediaQuery.large} {
   height: ${props.isSuggestedItem ? '269px' : '325px'};
 }`
      : `
    aspect-ratio: 332 / 412;
    object-fit: cover;
    display: block;
 `}

  & > a {
    display: flex;
    justify-content: center;
  }

  &.image-tile-border {
    border: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    ${(props) => (props.isPLPImageHeightBasedOnAspectRatio ? 'width:100%;' : '')}
  }
`;

export const StyledExtendedSizeText = Styled(BodyCopy)`
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  display: block;
  height: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};

  @media ${(props) => props.theme.mediaQuery.medium} {
    height: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    height: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
  }
`;

export const StyledFavoriteEditItemButton = Styled.div`
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => (props.isItemView ? 'height: 16px;' : '')};
  }
`;

export const StyledSeeSuggestedItem = Styled(BodyCopy)`
  @media ${(props) => props.theme.mediaQuery.large} {
    background: transparent;
    border: 0;
    text-decoration: underline;
  }
`;

export const StyledCloseButton = Styled.button`
  padding: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  margin-left: 10px;
  cursor: pointer;
  border: 0;
  background: transparent;
  position: absolute;
  right: 0px;
  top: 0;
  height: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  flex-direction: row;
  justify-content: flex-end;
`;

export const StyledCloseButtonIcon = Styled.svg`
  width: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  height: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
`;

export const StyledNoRatingSpaceMobileSNJ = Styled.div`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    height: 34px;
  }
`;

export const StyledSuggestedLabel = Styled(BodyCopy)`
  background: ${(props) => props.theme.colorPalette.gray[800]};
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  width: 100px;
  margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0px;
  @media ${(props) => props.theme.mediaQuery.medium} {
    margin: 6px 0px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    margin: 20px 0px;
  }
`;

const styles = css`
  width: 100%;
  max-width: ${(props) => (props.isFavPage ? '' : '261px')};
  height: 100%;

  .fav-icon-wrapper {
    text-align: right;
    display: flex;
    justify-content: flex-end;
  }
  .fav-icon-disabled {
    pointer-events: none;
  }
  .extended-sizes-text-wrapper {
    width: auto;
  }
  .ranking-wrapper {
    margin-top: auto;
    flex: initial;
  }

  .favorite-count {
    text-align: center;
    line-height: 1;
    display: none;
  }
  .clear-button {
    border: none;
    background: transparent;
    width: 35px;
    outline: none;
    padding-left: 16px;
    padding-top: 0;
    ${(props) => (props.isSearchPage ? 'padding-left: 0;' : '')};
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding: 0;
      margin: 0;
      padding-left: 16px;
      margin-top: -1px ${(props) => (props.isSearchPage ? 'padding-left: 0;' : '')};
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-top: 0 ${(props) => (props.isSearchPage ? 'margin-left: -5px;' : '')};
    }
  }

  .fav-heart-svg {
    width: 20px;
    padding-left: 10px;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 24px;
      padding-left: 0px;
    }
  }
  .fav-new-svg {
    position: relative;
    z-index: 1;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 22px;
    padding-top: 2.5px;
    border: ${(props) =>
      props.isFavPage ? '' : `1px solid ${props.theme.colors.PRIMARY.LIGHTERGRAY}`};
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 36px;
      height: 36px;
    }
    :hover {
      .empty-favorite-2 {
        fill: ${(props) => props.theme.colors.NOTIFICATION.ERROR};
        stroke: ${(props) => props.theme.colors.NOTIFICATION.ERROR};
        stroke-linecap: round;
        stroke-linejoin: round;
      }
    }
  }

  .svg-fav-page {
    top: 50px;
    left: 110px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      top: 98px;
      left: 122px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      top: 84px;
      left: 180px;
    }
    @media (min-width: 1200px) and (max-width: 1350px) {
      top: 104px;
      left: 126px;
    }
    @media (min-width: 1350px) and (max-width: 1600px) {
      left: 158px;
    }
  }

  .fav-svg-heart {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      width: 18px;
      height: 16px;
    }
  }
  .fav-icon {
    svg {
      width: 20px;
      @media ${(props) => props.theme.mediaQuery.large} {
        width: 24px;
      }
      cursor: pointer;
    }
  }

  .list-price-container {
    padding-right: 10px;
  }

  .list-price {
    text-decoration: line-through;
  }

  .product-title-container {
    margin-top: 0;
    box-sizing: border-box;
    ${(props) =>
      !props.isTileRedesignAB &&
      `height: ${
        props.isShowBrandNameEnabled || props.isRecommendationProductInfoEnabled
          ? `57px !important`
          : `36px`
      };`}
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }

  .floating-atb-btn {
    position: absolute;
    height: min-content;
    right: 0;
    top: 0;
  }

  .product-brand-plp {
    color: ${(props) => props.theme.colors.TEXT.BRANDGRAY};
    ${(props) => (props.isNewPLPAtbCardTileEnabled ? 'margin-bottom:0;' : '')}
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    }
    font-size: ${(props) => (props.isRecommendationProductInfoEnabled ? `10px` : ``)};
  }

  .video-container {
    min-height: 182px;
    align-items: center;
    display: flex;
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 320px;
      cursor: pointer;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      min-height: 245px;
    }
  }

  .purchase-section {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 16px;
    }
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }

  .is-purchase-label {
    display: inline-block;
    padding-left: 2px;
  }

  .create-wish-list-section {
    padding: 8px 16px 20px;
    font-size: 14px;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }

  .create-wish-list-header {
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 16px;
  }

  .wish-list-name {
    text-transform: capitalize;
  }

  .wish-list-count-section {
    text-transform: lowercase;
    display: inline-block;
    padding-right: 2px;
    padding-top: 3px;
  }

  .default-list-item,
  .default-list-count {
    font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
  }

  .create-new__button {
    margin-top: 28px;
  }

  .product-sku-info-container {
    font-size: 12px;
    color: ${(props) => props.theme.colors.ANCHOR.PRIMARY};
    text-transform: capitalize;
  }

  .wish-list-item-section {
    display: flex;
    justify-content: space-between;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }

  .wish-list-item__button {
    text-align: left;
    width: 100%;
    &:focus {
      background: transparent;
    }
  }

  .move-item-button {
    min-height: 20px;
  }

  .edit-fav-item__button {
    font-size: 14px;
    font-family: nunito;
    color: #595959;
    font-weight: 700;
    text-align: end;
    @media ${(props) => props.theme.mediaQuery.medium} {
      text-align: center;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    }
    text-decoration: underline;
  }

  .remove-fav-item__button {
    font-size: 14px;
    font-family: nunito;
    color: #c8102e;
    font-weight: 700;
    text-align: end;
    @media ${(props) => props.theme.mediaQuery.medium} {
      text-align: center;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    }
    text-decoration: underline;
  }

  .wish-list-tick-mark {
    vertical-align: bottom;
  }

  .loyalty-text-container {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    visibility: hidden;
    color: ${(props) =>
      props.isPlcc
        ? props.theme.colorPalette.userTheme.plcc
        : props.theme.colorPalette.userTheme.mpr};
    box-sizing: border-box;
    span {
      visibility: visible;
    }

    ${(props) =>
      `font-size: 11px;
      height: 15px;
      @media (min-width: 1200px) and (max-width: 1251px) {
        height: 20px;
      }
      @media ${props.theme.mediaQuery.smallMax} {
        font-size:9px;
      }
    `}
  }

  /* stylelint-disable-next-line*/
  _:-ms-fullscreen {
    max-height: 320px;
  }

  .sold-out-section {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background-color: rgba(255, 255, 255, 0.7);
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .container-price {
    white-space: nowrap;
    ${(props) =>
      props.isTileRedesignAB || props.isFavoriteView || props.isFavPage ? '' : 'min-height: 39px;'};

    .fav-redesign {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 0px;
      ${(props) => getPLPSLPAddToCartCTAStyle(props)}
    }
  }

  .main-price {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      line-height: 1em;
      padding-right: 4px;
    }
  }

  .top-badge-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(50%);
  }

  .top-badge-container div:last-child {
    margin-right: 0;
  }

  .extended-sizes-text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    @media ${(props) => props.theme.mediaQuery.large} {
      max-width: 165px;
    }
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      max-width: 195px;
    }
    @media ${(props) => props.theme.mediaQuery.desktop} {
      height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }

  .relative {
    position: relative;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .container-price {
      ${(props) => {
        if ((props.isTileRedesignAB && !props.isFavoriteView) || props.isFavPage) {
          return '';
        }
        return props.isFavoriteView ? 'min-height: 50px' : 'min-height: 47px';
      }};
    }
  }

  .wrap-text {
    flex-wrap: wrap;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    .container-price {
      margin-top: 0px;
      ${(props) => getPLPSLPAddToCartCTAStyle(props)}
    }

    .main-price {
      line-height: 1em;
      padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
    .product-title-container {
      ${(props) =>
        (!props.isTileRedesignAB || !props.isFavPage) &&
        `height: ${props.isShowBrandNameEnabled ? '62px' : '46px'}`};
    }

    &:hover {
      .button-prev {
        display: block;
      }
      .button-next {
        display: block;
      }
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    height: 100%;
    .close-btn-icon {
      width: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }
  .hr-plp.product-image-container {
    height: auto !important;
    img {
      position: relative;
      top: 0;
      left: 0;
      transform: none;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 244px;
    }
    @media (min-width: 1920px) {
      height: ${(props) => (props.theme.brand === 'snj' ? '100%' : '300px')};
    }
  }

  .fav-redesign.product-image-container {
    background: #f3f3f3;
  }

  .color-chips-container {
    ${(props) =>
      props.isNewPLPAtbCardTileEnabled &&
      `
      @media ${props.theme.mediaQuery.smallMax} {
        height: 36px;
        }

       .arrowRightWrapper{
        top:0px;
        @media ${props.theme.mediaQuery.smallOnly} {
          top:5px;
        }
      }
      .content-colors-button{
        height:24px;
        width:24px;
      }
      .mobile-content-colors{
        margin: 4px 2px;
      }
    `}
  }
  .multiline-ellipsis {
    ${(props) =>
      props.isRecommendationProductInfoEnabled &&
      ` font-size:12px;
      `};
  }
  .plp-new-product-tile {
    flex: 1;
    .plp-new-fav-icon {
      margin: 0px;
      position: absolute;
      right: 0px;
      @media ${(props) => props.theme.mediaQuery.large} {
        margin: 0px;
      }
    }
    .product-title-container {
      padding-top: 0;
      margin-bottom: ${(props) => (props.isNewPLPAtbCardTileEnabled ? '0' : '16px')};

      @media ${(props) => props.theme.mediaQuery.smallMax} {
        ${(props) => !props.isTileRedesignAB && `height: 62px;`}
      }
    }
    .plp-new-rating-wrapper {
      height: 18px;
      margin-bottom: 10px;

      @media ${(props) => props.theme.mediaQuery.smallMax} {
        height: 16px;
        margin-bottom: 5px;
      }
    }
    .plp-new-promotion-wrapper {
      height: 18px;
      margin: 8px 0;

      @media ${(props) => props.theme.mediaQuery.smallMax} {
        height: 10px;
        margin: 4px 0;
      }
    }
  }

  .plp-new-product-tile .product-title-container .product-brand-plp {
    font-size: 14px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 12px;
    }
  }

  .plp-new-product-tile .product-title-container .multiline-ellipsis {
    font-size: 16px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 14px;
    }

    ${(props) =>
      props.isSLP && props.isTileRedesignAB
        ? `
    min-height: 43px;
    @media ${props.theme.mediaQuery.smallMax} {
      min-height: 38px;
    }`
        : ''}
  }

  .slp-inner-container-inline {
    display: inline-flex;
    justify-content: space-between;
    ${(props) => props.isFavPage && `margin-top: 16px`};
    ${(props) => props.isTileRedesignAB && `position: relative`};
  }

  .badge-container {
    min-height: 26px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      min-height: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_1};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      min-height: 31px;
    }
  }

  .slp-inner-container-pjp {
    display: flex;
    justify-content: space-between;
  }

  .fulfillment-section {
    ${(props) => (props.isFavoriteView && props.isGuestFav ? '' : `margin-top: auto;`)}
  }

  .slp-favorite-icon {
    position: absolute;
    top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    margin: 0;

    & .clear-button {
      width: unset;
      padding: 0 !important;
    }
  }

  .zone-one-badges-wrapper {
    @media ${(props) => props.theme.mediaQuery.largeOnly} {
      column-gap: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
      height: ${(props) => props.theme.spacing.ELEM_SPACING.REG};

      .zone-one-badge-label {
        font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy_small}px;
      }
    }
  }

  .atb-button-slp-spacing {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};

    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
  }

  .remove-favorite {
    ${(props) =>
      props.isFavoriteView &&
      props.isGuestFavWeb &&
      !props.isLoggedIn &&
      `  @media ${props.theme.mediaQuery.smallOnly} {
        margin-top: ${props.theme.spacing.ELEM_SPACING.XXS};
      }
      @media ${props.theme.mediaQuery.medium} {
        margin-top: ${props.theme.spacing.ELEM_SPACING.XXS};
      }
      `}

    ${(props) =>
      props.isFavoriteView &&
      props.isGuestFavWeb &&
      props.isLoggedIn &&
      `  @media ${props.theme.mediaQuery.smallOnly} {
            margin-top: auto;
          }`}
  }
  .product-wishlist-container {
    ${(props) =>
      props.isFavoriteView &&
      props.isGuestFavWeb &&
      props.isLoggedIn &&
      ` @media ${props.theme.mediaQuery.medium} {
      margin-top: auto;
    }
    @media ${props.theme.mediaQuery.smallOnly} {
      margin-top: auto;
    }}
    `}
  }
`;

export default styles;
